import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  '$innerRoot.MuiRadio-colorPrimary:hover': {
    background: 'none',
  },
  checkedIcon: {},
  formControl: {
    margin: 0,
  },
  formControlLabel: {
    marginLeft: theme.spacing(1.5),
  },
  icon: {
    '$root.Mui-focusVisible &': {
      outline: `2px auto ${theme.palette.common.blue400}`,
      outlineOffset: 2,
    },
    '&$checkedIcon': {
      '&:before': {
        backgroundImage: `radial-gradient(${theme.palette.common.blue400},${theme.palette.common.blue400} 36%,transparent 32%)`,
        content: '""',
        display: 'block',
        height: 16,
        width: 16,
      },
      backgroundColor: theme.palette.common.blue400,
      backgroundImage: `linear-gradient(180deg,${theme.palette.common.white},${theme.palette.common.white})`,
      boxShadow: `inset 0 0 0 1px ${theme.palette.common.blue400}, inset 0 -1px 0 ${theme.palette.common.blue400}`,
      'input:hover ~ &': {
        backgroundColor: theme.palette.common.blue400,
        boxShadow: `inset 0 0 0 1px ${theme.palette.common.blue400}, inset 0 -1px 0 ${theme.palette.common.blue400}`,
      },
    },
    '&.error': {
      boxShadow: `inset 0 0 0 1px ${theme.palette.common.red400}, inset 0 -1px 0 ${theme.palette.common.red400}`,
    },
    backgroundColor: theme.palette.common.white,
    borderRadius: '50%',
    boxShadow: `inset 0 0 0 1px ${theme.palette.common.gray300}, inset 0 -1px 0 ${theme.palette.common.gray300}`,
    height: 16,
    'input:disabled ~ &': {
      background: theme.palette.common.gray200,
      boxShadow: 'none',
    },
    'input:hover ~ &': {
      backgroundColor: theme.palette.common.white,
      boxShadow: `inset 0 0 0 1px ${theme.palette.common.gray500}, inset 0 -1px 0 ${theme.palette.common.gray500}`,
    },
    transition: 'box-shadow 0.3s ease',
    width: 16,
  },
  root: {
    '&.Mui-checked:hover, &:hover': {
      backgroundColor: 'transparent',
    },
    padding: 0,
  },
}));

export default useStyles;
